// Il testo di un compito scritto in Markdown, letto come una frase: niente titoli, elenchi o segni
// di enfasi. Per le schede, dove il testo intero sta nel title (2026-11-02: in Pianifica la scheda
// mostrava «# test ## Requisiti ## Obiettivo …»).
export function excerpt(markdown: string): string {
  const lines = markdown.split('\n').map((l) => l.trim());
  const body = lines.filter((l) => l && !l.startsWith('#') && !/^[-*_]{3,}$/.test(l));
  const chosen = body.length ? body : lines.filter(Boolean).map((l) => l.replace(/^#+\s*/, ''));
  return chosen
    .map((l) => l.replace(/^([-*+]|\d+\.)\s+/, '').replace(/^>\s?/, ''))
    .join(' ')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/[*_`]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
